document.addEventListener('DOMContentLoaded', () => {
    function userNotLoggedInHandler (contextObj) {
        TurnToCmd('loggedInDataFnDone', { context: contextObj, loggedInData: null });
    }
    const page = $('.page').data('action');
    const turnToConfig = {
        locale: $('#turnToWidgetLocale').data('value'),
        sso: {
            userDataFn: function (contextObj) {
                $.ajax({
                    url: $('#turntoUrlUserData').data('url'),
                    type: 'POST',
                    success: function (data) {
                        const userToken = data.userDataToken;
                        const isUserLoggedIn = data.isUserLoggedIn;
                        if (!isUserLoggedIn) {
                            window.location.href = data.redirectUrl;
                        } else {
                            TurnToCmd('ssoRegDone', { context: contextObj, userDataToken: userToken });
                        }
                    }
                });
            },
            loggedInDataFn: function (contextObj) {
                $.post({
                    url: $('#turntoUrlUserData').data('url'),
                    success: function (data) {
                        const isUserLoggedIn = data.isUserLoggedIn;
                        if (!isUserLoggedIn) {
                            userNotLoggedInHandler(contextObj);
                        } else {
                            $.post({
                                url: $('#turntoUrlLoggedInData').data('url'),
                                success: function (data) {
                                    TurnToCmd('loggedInDataFnDone', { context: contextObj, loggedInData: data });
                                },
                                error: function () {
                                    userNotLoggedInHandler(contextObj);
                                }
                            });
                        }
                    },
                    error: function () {
                        userNotLoggedInHandler(contextObj);
                    }
                });
                if (window.isUserLoggedIn) {
                    $.ajax({
                        url: $('#turntoUrlLoggedInData').data('url'),
                        type: 'POST',
                        success: function (data) {
                            TurnToCmd('loggedInDataFnDone', { context: contextObj, loggedInData: data });
                        }
                    });
                } else {
                    TurnToCmd('loggedInDataFnDone', { context: contextObj, loggedInData: null });
                }
            },
            logout: function () {
                $.ajax({
                    url: $('#turntoUrlLoggedOut').data('url'),
                    type: 'POST',
                    success: function (data) {
                    }
                });
            }
        }
    };
    switch (page) {
    case 'Product-Show':
        turnToConfig.pageId = 'pdp-page';
        turnToConfig.sku = $('#reviewSku').val();
        break;
    default:
        break;
    }
    window.turnToConfig = turnToConfig;
    window.TurnToCmd = window.TurnToCmd || function () { (TurnToCmd.q = TurnToCmd.q || []).push(arguments); };
    const $turnToScript = $('#turnToWidgetScript');
    const siteKey = $('#turnToSiteKey').data('value');
    if ($turnToScript.length > 0) {
        $turnToScript.get(0).onload = function () {
            const ratingsReviewsNode = document.getElementById('ratingsReviewsSection');
            function setupFilters () {
                const filtersCallback = function(mutationsList, observer) {
                    for (let index = 0; index < mutationsList.length; index++) {
                        let mutation = mutationsList[index];
                        if (mutation.type === 'childList') {
                            const $filterListNode = $('.tt-c-reviews-list-utilities');
                            const $reviewsSummaryNode = $('.tt-l-grid.tt-c-reviews-summary__content.only-stars');
                            if ($filterListNode.length && $reviewsSummaryNode.length) {
                                observer.disconnect();
                                $('.tt-c-reviews-list-utilities').addClass('grid-container');
                                $filterListNode.find('.tt-c-review-filters .tt-o-listbox .tt-o-listbox__btn .tt-o-listbox__label').html($('#filterLabel').html());
                                $filterListNode.find('.tt-c-reviews-toolbar .tt-o-listbox.tt-c-reviews-toolbar__sort .tt-o-listbox__btn .tt-o-listbox__label').html($('#sortLabel').html());
                                $('.tt-c-review-filters .tt-o-listbox__option').on('click', function () {
                                    if (!Foundation.MediaQuery.atLeast('medium')) {
                                        $('.tt-c-review-filters .tt-o-listbox .tt-o-listbox__btn').click();
                                    }
                                });
                                $('.tt-c-reviews-toolbar .tt-c-reviews-toolbar__sort .tt-o-listbox__list .tt-o-listbox__option').on('click', function () {
                                    if (!Foundation.MediaQuery.atLeast('medium')) {
                                        $('.tt-c-reviews-toolbar .tt-c-reviews-toolbar__sort .tt-o-listbox__btn').click();
                                    }
                                });
                                $filterListNode.appendTo($reviewsSummaryNode);
                            }
                        }
                    }
                };
                const filtersObserver = new MutationObserver(filtersCallback);
                const config = { attributes: false, childList: true, subtree: true };
                filtersObserver.observe(ratingsReviewsNode, config);

            }
            function setupLayout () {
                $('.ratings-reviews-section #tt-reviews-list .tt-c-reviews-list__content').addClass('grid-container');
            }

            function setupReviewSummary() {
                $('.review-summary-pdp.loaded').empty().off('click');
                $('.cc-details-accordion.accordion-description').addClass('cc-no-border');
            
                const ratingsReviewsNode = document.getElementById('ratingsReviewsSection');
                if (!ratingsReviewsNode) return;
            
                const observer = new MutationObserver((mutations, obs) => {
                    const $starSummaryNode = $('.tt-c-rating.tt-c-reviews-summary__stars');
                    
                    if ($starSummaryNode.length) {
                        const stickyBannerHeight = $('nav').outerHeight() || 0;
            
                        const $ratingNumber = $('.tt-c-reviews-summary__rating-number');
                        let ratingValue = '';

                        if ($ratingNumber.length) {
                            ratingValue = $ratingNumber.text().trim();
                        }

                        const $clonedStars = $starSummaryNode.clone();
                        const $reviewSummary = $('.review-summary-pdp').addClass('loaded');
                        $('.cc-details-accordion.accordion-description').removeClass('cc-no-border');
        
                        const $ratingContainer = $('<div class="cc-rating-container"></div>');
                        $ratingContainer.append($clonedStars);

                        if (ratingValue) {
                            $ratingContainer.append(`<span class="cc-rating-value">${ratingValue}/5</span>`);
                        }

                        $ratingContainer.prependTo($reviewSummary);

                        $('.review-summary-pdp').off('click').on('click', function() {
                            const $target = $('#tt-reviews-summary');
                            if (!$target.length) return;
            
                            const extraHeight = Foundation?.MediaQuery?.atLeast('medium') ? 
                                                stickyBannerHeight : 0;
            
                            $('html, body').animate({
                                scrollTop: $target.offset().top - extraHeight
                            }, 1500);
                        });
            
                        if ($('#tt-reviews-list.hidden').length) {
                            $('#tt-reviews-summary .tt-c-reviews-summary__content')
                                .addClass('only-stars');
                        }
            
                        obs.disconnect();
                    }
                });
            
                observer.observe(ratingsReviewsNode, {
                    childList: true,
                    subtree: true
                });
            
                if ($('.tt-c-rating.tt-c-reviews-summary__stars').length) {
                    observer.takeRecords();
                }
            }



            $('.tt-o-page-list__number').on('click', function () {
                insertStaticLabels();
            });
            window.addEventListener('resize', () => {
                insertStaticLabels();
            });

            const setupPagination = () => {
                let ratingsReviewsNode = $('#ratingsReviewsSection').get(0);
                let ratingsReviewsNodeCallback = function (mutationsList, observer) {
                    for (let index = 0; index < mutationsList.length; index++) {
                        let mutation = mutationsList[index];
                        if (mutation.type === 'childList') {
                            const $paginationNode = $('.tt-o-pagination');
                            if ($paginationNode.length > 0) {
                                updatePagination($paginationNode.find('.tt-o-page-list .tt-o-page-list__number'));
                                const handlePaginationClick = () => {
                                    updatePagination($paginationNode.find('.tt-o-page-list .tt-o-page-list__number'));
                                };
                                $('body').on('click', '.tt-o-page-list__number', (event) => {
                                    handlePaginationClick();
                                });
                                observer.disconnect();
                            }
                        }
                    }
                };

                let reviewsListObserver = new MutationObserver(ratingsReviewsNodeCallback);
                const config = { attributes: false, childList: true, subtree: true };
                reviewsListObserver.observe(ratingsReviewsNode, config);
            };

            let updatePagination = ($paginationNodes) => {
                const paginationNodesArr = $paginationNodes.toArray();
                const totalPages = paginationNodesArr.length;

                if (!totalPages) return;

                const firstPage = 0;
                const lastPage = totalPages - 1;

                $('.tt-o-page-list__gap').remove();

                if (totalPages === 1) {
                    $(paginationNodesArr[0]).show();
                    return;
                }

                const activeNodeIndex = paginationNodesArr.findIndex(node =>
                    $(node).hasClass('tt-is-active')
                );

                const visibleRange = Math.min(2, Math.floor(totalPages / 5));
                let startPage = Math.max(activeNodeIndex - visibleRange, 1);
                let endPage = Math.min(activeNodeIndex + visibleRange, lastPage - 1);

                paginationNodesArr.forEach(node => $(node).hide());
                $(paginationNodesArr[firstPage]).show();

                if (startPage > 1) {
                    $('<span class="tt-o-page-list__gap">…</span>')
                        .insertAfter($(paginationNodesArr[firstPage]));
                }
                for (let i = startPage; i <= endPage; i++) {
                    $(paginationNodesArr[i]).show();
                }
                if (endPage < lastPage - 1) {
                    $('<span class="tt-o-page-list__gap">…</span>')
                        .insertBefore($(paginationNodesArr[lastPage]));
                }

                $(paginationNodesArr[lastPage]).show();
            };

            const insertStaticLabels = () => {
                let $reviewNodesReview = $('#ratingsReviewsSection').get(0);
                let ratingsReviewsNodeCallback = function (mutationsList, observer) {
                    for (let index = 0; index < mutationsList.length; index++) {
                        let mutation = mutationsList[index];
                        if (mutation.type === 'childList') {
                            const $reviewNodes = $('.tt-c-dimension--2 .tt-c-dimension__heading .tt-c-dimension__value-label');
                            if ($reviewNodes.length > 0) {
                                setTimeout(function () {
                                    $('.tt-c-dimension--2').each(function () {
                                        var $label = $(this).find('.tt-c-dimension__heading .tt-c-dimension__value-label');
                                        var value = $label.html();
                                        if (value.length === 1) {
                                            $label.html(value + '/5');
                                        } else if (!value.endsWith('/5')) {
                                            $(this).find('.tt-c-dimension__bar-wrap .size-label-container').remove();
                                            $(this).find('.tt-c-dimension__bar-wrap').each(function () {
                                                $(this).append($('.size-label-container').first().clone());
                                            });
                                        }
                                    });
                                }, 0);
                                observer.disconnect();
                            }
                        }
                    }
                };

                let reviewsListObserver = new MutationObserver(ratingsReviewsNodeCallback);
                const config = { attributes: false, childList: true, subtree: true };
                reviewsListObserver.observe($reviewNodesReview, config);
            };

            setupReviewSummary();
            setupPagination();
            setupLayout();
            insertStaticLabels();
            setupFilters();
        };

        let setupTitleSection = () => {
            let titleNode = $('#tt-reviews-summary').get(0);
            let titleCallback = function (mutationsList, observer) {
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'childList') {
                        const $nodeBeforeTitle = $('.tt-l-grid.tt-c-reviews-summary__content .tt-l-grid__row.tt-c-reviews-summary__grid-row').get(0);
                        if ($nodeBeforeTitle) {
                            $('#ratingsReviewsTitle').removeClass('hidden').insertAfter($nodeBeforeTitle);
                            $('.tt-c-review-filters .tt-o-listbox .tt-o-listbox__list').appendTo('.flcFilterContainer .js-filterMenuDesktop');
                            observer.disconnect();
                        }
                    }
                }
            };
            let reviewsListObserver = new MutationObserver(titleCallback);
            const config = { attributes: false, childList: true, subtree: true };
            reviewsListObserver.observe(titleNode, config);
        };

        let setupOnlyStarredReviewsList = () => {
            let reviewsListNode = $('#tt-reviews-list').get(0);
            let reviewsListCallback = function (mutationsList, observer) {
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'childList' &&
                    mutation.target.className === 'tt-c-reviews-list' &&
                    mutation.target.children.length > 0) {
                        $('#tt-reviews-list').removeClass('hidden');
                        observer.disconnect();
                        
                        break;
                    } else {
                        $('#tt-reviews-list').addClass('hidden');
                    }
                }
            };
            let reviewsListObserver = new MutationObserver(reviewsListCallback);
            const config = { attributes: false, childList: true, subtree: true };
            reviewsListObserver.observe(reviewsListNode, config);
        };

        setupTitleSection();
        setupOnlyStarredReviewsList();
        $turnToScript.attr('src', 'https://widgets.turnto.com/v5/widgets/' + siteKey + '/js/turnto.js');
    }
    $('body').on('click', '.tt-c-reviews-filters-row .tt-o-listbox__list--has-selection .tt-o-listbox__option', function (e) {
        let index = $(e.currentTarget).index();
        let word = '';
        if (index === 0) {
            word = '5_stars';
        } else if (index === 1) {
            word = '4_stars';
        } else if (index === 2) {
            word = '3_stars';
        } else if (index === 3) {
            word = '2_stars';
        } else if (index === 4) {
            word = '1_star';
        }
        $('body').trigger('analytics:ratingAndReviewsPdp', {action: 'apply_a_filter', word: word});
    });
    $('body').on('click', '.tt-c-reviews-toolbar__sort .tt-o-listbox__list .tt-o-listbox__option', function (e) {
        let index = $(e.currentTarget).index();
        let word = '';
        if (index === 0) {
            word = 'most_recent';
        } else if (index === 1) {
            word = 'most_helpful';
        } else if (index === 2) {
            word = 'oldest';
        } else if (index === 3) {
            word = 'best_reviewed';
        } else if (index === 4) {
            word = 'least_reviewed';
        }
        $('body').trigger('analytics:ratingAndReviewsPdp', {action: 'apply_a_sorting', word: word});
    });
});
